import { render } from "./PreSale.vue?vue&type=template&id=fdc869f2&scoped=true"
import script from "./PreSale.vue?vue&type=script&lang=js"
export * from "./PreSale.vue?vue&type=script&lang=js"

import "./PreSale.vue?vue&type=style&index=0&id=fdc869f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdc869f2"]])

export default __exports__